import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { popperGenerator, defaultModifiers } from '@popperjs/core/lib/popper-lite';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow';
import offsetModifier from '@popperjs/core/lib/modifiers/offset';
import arrowModifier from '@popperjs/core/lib/modifiers/arrow';
import hideModifier from '@popperjs/core/lib/modifiers/hide';
import { padding, fit } from './utils';
export var createPopper = popperGenerator({
  defaultModifiers: [].concat(_toConsumableArray(defaultModifiers), [preventOverflow, offsetModifier, arrowModifier, hideModifier])
});
export var arrow = {
  name: 'arrow',
  options: {
    padding: 2
  }
};
export var offset = {
  name: 'offset',
  options: {
    offset: [0, padding]
  }
};
export var overflow = function overflow(containerEl) {
  return {
    name: 'preventOverflow',
    options: {
      boundary: containerEl
    }
  };
};
export var adaptiveDirection = function adaptiveDirection(containerEl, directionEl) {
  return {
    name: 'direction',
    enabled: true,
    phase: 'beforeRead',
    fn: function fn(_ref) {
      var state = _ref.state;
      state.placement = fit({
        containerEl: containerEl,
        controlEl: state.elements.reference,
        tooltipEl: state.elements.popper,
        directionEl: directionEl
      });
    }
  };
};
export var silent = [offset, {
  name: 'eventListeners',
  enabled: false
}, {
  name: 'computeStyles',
  enabled: false
}];